import React, { useEffect } from 'react';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import CONFIG from './config';
import Themes from './styles/themes';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import PageContainer from './components/PageContainer/PageContainer';
import { IContent } from './types';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppDispatch, RootState } from './store';
import { fetchAppSetup } from './store/features/app/app';

const mapStateToProps = (state: RootState) => ({
    app: state.app,
});

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
    fetchAppSetup: bindActionCreators(fetchAppSetup, dispatch)
});

const connector = connect(mapStateToProps, mapDisPatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = ({
   localeId,
   fetchAppSetup
 }: AppProps) => {
  const localizedContent: IContent = data.filter(
    locale => locale.lang === localeId
  )[0];

  useEffect(() => {
    fetchAppSetup();
  }, []);

  return (
    <main id="cloud-gaming-page">
      <ContentProvider value={localizedContent}>
        <ThemeProvider theme={Themes[CONFIG.isUPC ? 'Uplay' : 'Store']}>
          <StyleSheetManager
              target={document.querySelector("#stylesheetsContainer")}
              disableCSSOMInjection={true}
          >
            <PageContainer/>
          </StyleSheetManager>
        </ThemeProvider>
      </ContentProvider>
    </main>
  );
};
export default connector(App);
